import React, { FC } from 'react'

import { useIsMobileOrBelow } from 'core/hooks'
import { NewsfeedEntry, NewsfeedRecordType } from 'core/interfaces'
import { newsfeedLink } from 'core/utils'
import { DEVELOPER_ARTICLE_CATEGORIES } from 'core/constants'

import { NewsCard } from '../../../../components/news-card/NewsCard'

import classes from './style.module.scss'

interface ComponentProps {
  items: NewsfeedEntry[]
}

export const NewsSection: FC<ComponentProps> = ({ items }) => {
  const isMobileOrBelow = useIsMobileOrBelow()

  const newsArticles = items.filter((item) =>
    item.type === NewsfeedRecordType.Article &&
    !DEVELOPER_ARTICLE_CATEGORIES.includes(item.category)
  )
  const events = items.filter((item) => item.type === NewsfeedRecordType.Event)
  const allItems = [...newsArticles, ...events]

  if (!allItems.length) return null

  let displayItems: NewsfeedEntry[]

  if (isMobileOrBelow) {
    displayItems = allItems.slice(0, 3)
  } else {
    // Desktop: 1 featured + up to 2 news + up to 2 events (fill remaining slots if needed)
    const featured = allItems[0]
    const remaining = allItems.slice(1)
    const isFeaturedNews = featured.type === NewsfeedRecordType.Article

    const availableNews = newsArticles.slice(isFeaturedNews ? 1 : 0)
    const availableEvents = events.slice(isFeaturedNews ? 0 : 1)

    const twoNews = availableNews.slice(0, 2)
    const twoEvents = availableEvents.slice(0, 2)
    const combined = [...twoNews, ...twoEvents]

    // Fill remaining slots (up to 4 total) if we don't have enough news/events
    const needed = 4 - combined.length
    if (needed > 0) {
      const extraItems = remaining.filter((item) => !combined.includes(item)).slice(0, needed)
      displayItems = [featured, ...combined, ...extraItems]
    } else {
      displayItems = [featured, ...combined]
    }
  }

  return (
    <div className={classes.container}>
      {displayItems.map((item, index) => (
        <div
          key={index}
          className={`${classes.gridItem} ${index === 0 ? classes.featuredItem : classes.regularItem}`}
        >
          <NewsCard
            category={item.type === NewsfeedRecordType.Article ? 'news' : 'events'}
            date={item.human_date}
            title={item.title}
            url={newsfeedLink(item)}
            image={item.bg_image.url}
            isBold={!isMobileOrBelow && index === 0}
          />
        </div>
      ))}
    </div>
  )
}